import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=b6622cc8&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=b6622cc8&prod&lang=less&scoped=true"
import style1 from "./HomeView.vue?vue&type=style&index=1&id=b6622cc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6622cc8",
  null
  
)

export default component.exports